import {
  Backdrop,
  Box,
  Button,
  Container,
  Divider,
  Fade,
  makeStyles,
  Modal,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import React, { useState } from 'react';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import {
  postMultiplePartialRolloutAsync,
  postPartialRolloutAsync,
} from './PartialRolloutStore/partialRolloutSlice';
import useToast from '../../../hooks/useToast';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    paddingLeft: 44,
    paddingRight: 44,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  premiumModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function PartialRolloutScreen() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();

  const [schoolId, setSchoolId] = useState('');
  const [type, setType] = useState('');
  const [file, setFile] = useState('');
  const [paramsData, setParamsData] = useState('pwa');
  const [path, setPath] = useState('enable');
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setType('');
  };

  const handleChangeSchoolId = (e) => {
    setSchoolId(e.target.value);
  };

  const handleUploadDocument = (e) => {
    if (e.target.files.length) {
      setFile(e.target.files[0]);
    }
  };

  const handlePartialRollout = () => {
    const data = new FormData();
    const KEY = 'file';
    data.append(KEY, file);
    switch (type) {
      // case 'Profile Page':
      //   // TODO fix payload
      //   dispatch(
      //     postPartialRolloutAsync({
      //       bodyData: [
      //         {
      //           domain: 'web',
      //           module: 'publishProfilePage',
      //           service: 'profilePage',
      //           feature: 'allowPublishingProfilePage',
      //           entityId: schoolId,
      //           entityName: 'school',
      //           status: 'active',
      //         },
      //       ],
      //     })
      //   )
      //     .unwrap()
      //     .then((res) => {
      //       if (res && res.status > 299) {
      //         ErrorToast(res.message);
      //       } else {
      //         SuccessToast('Success');
      //       }
      //     })
      //     .catch((err) => {
      //       ErrorToast(err.message);
      //     });
      //   break;
      case 'Microsite':
        // TODO fix payload
        dispatch(
          postPartialRolloutAsync({
            bodyData: {
              domain: 'web',
              module: 'publishPwa',
              service: 'microsite',
              feature: 'allowPublishingMicrosite',
              entityId: schoolId,
              entityName: 'school',
              status: 'active',
            },
          })
        )
          .unwrap()
          .then((res) => {
            SuccessToast('Allow Microsite for School Successfully');
          })
          .catch((err) => {
            ErrorToast(err.message);
          });
        break;
      case 'Story':
        // TODO fix payload
        dispatch(
          postPartialRolloutAsync({
            bodyData: {
              domain: 'web',
              module: 'story',
              service: 'createStory',
              feature: 'allowCreateStory',
              entityId: schoolId,
              entityName: 'school',
              status: 'active',
            },
          })
        )
          .unwrap()
          .then((res) => {
            SuccessToast('Allow Story Module for School Successfully');
          })
          .catch((err) => {
            ErrorToast(err.message);
          });
        break;
      case 'PWA and Story':
        // TODO fix payload
        dispatch(
          postMultiplePartialRolloutAsync({
            type: paramsData,
            path: path,
            bodyData: data,
          })
        )
          .unwrap()
          .then((res) => {
            SuccessToast('Multiple School Updated Successfully');
          })
          .catch((err) => {
            ErrorToast(err.message);
          });
        break;
      default:
        break;
    }
    setFile('');
    setSchoolId('');
    setType('');
    handleCloseModal();
  };

  return (
    <Container className={classes.overAll}>
      <Box display="flex" flex={1} justifyContent="center" alignItems="center">
        <Box flex={1} flexGrow={1}>
          <Typography variant="h4" component="div">
            <Box fontWeight="fontWeightMedium">Partial Rollout Management</Box>
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Managing Partial Rollout Features
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flex={10} pt={5}>
        <Box mr={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleOpenModal();
              setType('Microsite');
            }}>
            Allow Microsite for school
          </Button>
        </Box>
        <Box mr={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleOpenModal();
              setType('Story');
            }}>
            Allow Story module for school
          </Button>
        </Box>
        <Box mr={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleOpenModal();
              setType('PWA and Story');
            }}>
            Allow multiple schools for PWA and Story
          </Button>
        </Box>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.premiumModal}
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={openModal}>
          <Box
            sx={{
              height: 220,
              width: 500,
              bgcolor: 'white',
              px: 2,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              py: 2,
              borderRadius: '8px',
            }}>
            <Box>
              <Box display="flex" justifyContent={'space-between'}>
                <Box
                  fontFamily={'Rubik'}
                  fontSize={18}
                  fontWeight="bold"
                  mb={2}>
                  {type}
                </Box>
                <Box sx={{ cursor: 'pointer' }}>
                  <CloseIcon fontSize="medium" onClick={handleCloseModal} />
                </Box>
              </Box>
              {type === 'PWA and Story' ? (
                <>
                  <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel id="demo-select-small-label">
                      Select Module*
                    </InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      label="Select Module*"
                      required
                      value={paramsData}
                      onChange={(e) => setParamsData(e.target.value)}
                      fullWidth>
                      <MenuItem value={'pwa'}>PWA</MenuItem>
                      <MenuItem value={'story'}>Story</MenuItem>
                    </Select>
                  </FormControl>
                  <Box mt={2} />
                  <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel id="demo-select-small-label">
                      Select Option*
                    </InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      label="Select Option*"
                      required
                      value={path}
                      onChange={(e) => setPath(e.target.value)}
                      fullWidth>
                      <MenuItem value={'enable'}>Enable</MenuItem>
                      <MenuItem value={'disable'}>Disable</MenuItem>
                    </Select>
                  </FormControl>
                  <Box mt={2}>
                    <input
                      accept=".csv"
                      // style={{ backgroundColor: 'orange' }}
                      id="upload-brochure"
                      type="file"
                      onChange={handleUploadDocument}
                    />
                    <Typography style={{ fontSize: 12 }}>
                      Imp: Upload a .csv file (max size 2mb)
                    </Typography>
                  </Box>
                </>
              ) : (
                <BuzzInput
                  size={'small'}
                  required
                  label="School Id"
                  placeholder="Enter school id "
                  autoFocus
                  fullWidth
                  name="schoolId"
                  value={schoolId}
                  onChange={handleChangeSchoolId}
                />
              )}
            </Box>
            <Box display={'flex'} justifyContent="flex-end">
              <Box mr={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCloseModal}>
                  Cancel
                </Button>
              </Box>
              <Button
                disabled={schoolId === '' && file === ''}
                variant="contained"
                color="primary"
                onClick={handlePartialRollout}>
                Apply
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Container>
  );
}

export default PartialRolloutScreen;
